/**
 * Return thron thumbnail URL
 * @param contentId in format pKey@contentId
 * @returns {string}
 */
export default (contentId) => {
  if (typeof (contentId) !== 'string') {
    return '';
  }
  const parts = contentId.split('@');
  if (parts[0] === '' || parts[1] === undefined) {
    return '';
  }
  return `//valentino-cdn.thron.com/delivery/public/thumbnail/valentino/${parts[1]}/${parts[0]}/std/0x0/${parts[1]}`;
};
